import numeral from 'numeral'
import PropTypes from 'prop-types'
import React, { Component } from 'react'

import GenericAuto from '../../icons/GenericAuto'

// load a language
numeral.language('it', {
  delimiters: {
    thousands: '.',
    decimal: ',',
  },
  abbreviations: {
    thousand: 'k',
    million: 'm',
    billion: 'b',
    trillion: 't',
  },

  currency: {
    symbol: '€',
  },
})

class BuyRateBox extends Component {
  render() {
    numeral.language('it')
    numeral.defaultFormat('$ 0,0.00')

    const { calcolatrice } = this.props
    const { hideButton } = this.props
    const errorBoxVisible =
      this.props.error &&
      this.props.error.type &&
      this.props.error.type.startsWith('GET_DEFAULT_FINANCEMENTS')

    if (errorBoxVisible) {
      return (
        <div className="rate-box-wrapper">
          <div
            className={this.props.selected ? 'rate-box selected' : 'rate-box'}
            data-finanziamento="fin-1"
            onClick={this.props.handleHover}
            onMouseOver={this.props.handleHover}
            style={this.props.style}
          >
            <div className="modal_new_rate_logistica">
              <div className="error__popup__svg" style={{ paddingTop: '40px' }}>
                <GenericAuto />
              </div>

              <p>
                I finanziamenti per quest'auto non sono al momento disponibili.
                Rimane possibile procedere l'acquisto tramite bonifico.
              </p>

              <div style={{ fontSize: '9px', wordWrap: 'break-word' }}>
                {this.props.error.type ? (
                  <div>
                    {this.props.error.type}
                    <br />
                  </div>
                ) : null}

                {this.props.error && this.props.error.xray ? (
                  <div>
                    xray {this.props.error.xray}
                    <br />
                  </div>
                ) : null}
              </div>
            </div>
          </div>
        </div>
      )
    }

    return (
      <div className="rate-box-wrapper">
        <div
          className={this.props.selected ? 'rate-box selected' : 'rate-box'}
          data-finanziamento="fin-1"
          onClick={this.props.handleHover}
          onMouseOver={this.props.handleHover}
          style={this.props.style}
        >
          {this.props.brumbrum_loader_visible && (
            <div className="modal_new_rate_logistica">
              <div className="rate_loader_calcolo">
                <div className="loader__spinner" />
                <p>
                  Stiamo calcolando i finanziamenti includendo i costi di
                  consegna per la città che hai selezionato
                </p>
              </div>
            </div>
          )}

          {!this.props.brumbrum_loader_visible && (
            <div className="tan_taeg">
              {this.props.label ? (
                <div className="rate-label">{this.props.label}</div>
              ) : null}
              <span className="rata">
                <span>
                  {numeral(calcolatrice.importo_rata).format('$ 0,0')}
                </span>{' '}
                al mese
                <br />
                {!!this.props.numeroRate && `${this.props.numeroRate} Mesi`}
                {calcolatrice.rataAggiuntiva ? (
                  <>
                    <br />
                    {`Maxirata ${numeral(calcolatrice.rataAggiuntiva).format(
                      '$ 0,0'
                    )}`}
                  </>
                ) : null}
                <br />
                Tan fisso {numeral(calcolatrice.tan / 100).format('0.00%')}
                <br />
                Taeg {numeral(calcolatrice.taeg / 100).format('0.00%')}
                <br />
              </span>
              <hr />
              <div className="info">
                {this.props.acconti
                  ? `Acconto pre-autorizzato: ${numeral(
                      this.props.acconti
                    ).format()}\n`
                  : null}
                Acconto {this.props.acconti ? `residuo` : null}:{' '}
                {numeral(
                  this.props.acconti
                    ? calcolatrice.anticipo - this.props.acconti
                    : calcolatrice.anticipo
                ).format()}
                {calcolatrice.rataAggiuntiva && (
                  <>
                    <br />
                    {`Maxirata: ${numeral(calcolatrice.rataAggiuntiva).format(
                      '$ 0,0'
                    )}`}
                  </>
                )}
                <br />
                Importo finanziato:{' '}
                {numeral(calcolatrice.importo_finanziato).format()}
                <br />
                Rimborsabile in {calcolatrice.numero_rate} mesi
                <br />
              </div>
              {!hideButton && (
                <button
                  className="btn btn-primary x-small modal-btn"
                  data-cy={this.props.dataCy}
                  data-modal="pre-secci"
                  onClick={this.props.handleClick(
                    calcolatrice.id_finanziamento
                  )}
                >
                  <span>Richiedi</span>
                </button>
              )}
            </div>
          )}
        </div>

        {!this.props.brumbrum_loader_visible && calcolatrice.iebccUrl && (
          <div className="scarica-modulo-findomestic brumbrum-link">
            <a href={calcolatrice.iebccUrl} rel="noreferrer" target={'_blank'}>
              Scarica il modulo informativo (IEBCC)
            </a>
          </div>
        )}
      </div>
    )
  }
}

BuyRateBox.defaultProps = {
  error: null,
  brumbrum_loader_visible: false,
  acconti: 0,
  hideButton: false,
  selected: false,
}

BuyRateBox.propTypes = {
  error: PropTypes.object,
  calcolatrice: PropTypes.object.isRequired,
  handleHover: PropTypes.func.isRequired,
  selected: PropTypes.bool,
  brumbrum_loader_visible: PropTypes.bool,
  acconti: PropTypes.number,
  hideButton: PropTypes.bool,
}

export default BuyRateBox
